import Vue from 'vue';

const mutations = {
  setLocationFrom(state, locationFrom) {
    state.locationFrom = locationFrom;
  },
  setLocationTo(state, locationTo) {
    state.locationTo = locationTo;
  },
  clearDestinations(state) {
    state.from = null;
    state.to = null;
  },
  setPickUpRange(state, pickUpRange) {
    state.pickUpRange = pickUpRange;
  },
  clearPickUpRange(state) {
    state.pickUpRange = null;
  },
  completeCalculate(state, result) {
    state.calculated = true;
    state.calculateResult = result;
  },
  resetCalculation(state) {
    state.calculated = false;
    state.calculateResult = null;
  },
  setNearestServicePoints(state, servicePoints) {
    state.nearestServicePoints = servicePoints;
  },
  clearNearestServicePoints(state) {
    state.nearestServicePoints = [];
  },
  setP2pPServicePoints(state, servicePoints) {
    state.p2pPServicePoints = servicePoints;
  },
  clearP2pPServicePoints(state) {
    state.p2pPServicePoints = [];
  },
  addPiece(state, piece) {
    state.pieces.push(piece);
  },
  editPiece(state, piece) {
    state.pieces.splice(piece.id, 1, piece);
  },
  removePiece(state, position) {
    state.pieces.splice(position, 1);
  },
  setOrderType(state, orderType) {
    state.orderType = orderType;
  },
  setOrder(state, order) {
    state.selectedOrder = order;
  },
  setCenterCoordinateMap(state, coordinate) {
    state.centerCoordinateMap = coordinate;
  },
  clearCenterCoordinateMap(state) {
    state.centerCoordinateMap = [];
  },
  setServicePoints(state, servicePoints) {
    state.servicePoints = servicePoints;
  },
  setServicePointFrom(state, servicePoint) {
    state.servicePointFrom = servicePoint;
  },
  setServicePointTo(state, servicePoint) {
    state.servicePointTo = servicePoint;
  },
  setCalculatedProducts(state, products) {
    state.availableProducts = products;
  },
  resetCalculatedProducts(state) {
    state.availableProducts = [];
    state.selectedProduct = null;
    state.selectedExtras = [];
  },
  setProduct(state, product) {
    state.selectedProduct = product;
  },
  removeAllExtra(state) {
    state.selectedExtras = [];
    state.selectedExtrasAll = [];
  },
  addExtra(state, extra) {
    const newExtras = new Set(state.selectedExtras);
    const newExtrasAll = new Set(state.selectedExtrasAll);
    newExtrasAll.add(extra);

    if (!extra.isHidden) {
      newExtras.add(extra);
    }
    state.selectedExtras = [...newExtras];
    state.selectedExtrasAll = [...newExtrasAll];
  },
  removeExtra(state, extra) {
    state.selectedExtras = state.selectedExtras.filter((e) => e.code !== extra.code);
    state.selectedExtrasAll = state.selectedExtrasAll.filter((e) => e.code !== extra.code);
  },
  setSenderContacts(state, senderData) {
    state.senderContacts = senderData;
  },
  setReceiverContacts(state, receiverData) {
    state.receiverContacts = receiverData;
  },
  setDeclaredValue(state, value) {
    state.declaredValue = value;
  },
  setInsuredAmount(state, value) {
    state.insuredAmount = value;
  },
  enableCustomsDuty(state) {
    state.isCustomsDuty = true;
  },
  disableCustomsDuty(state) {
    state.isCustomsDuty = false;
  },
  updatePayment(state, payment) {
    state.selectedPayment = payment;
  },
  setOnlineCardPaymentEmail(state, email) {
    state.onlineCardPaymentEmail = email;
  },
  setCustomDutyAmount(state, value) {
    state.customDutyAmount = value;
  },
  updateSuccessShipmentResult(state, value) {
    state.successShipmentResult = value;
  },
  setExtraTestXK(state) {
    if (state.selectedProduct && state.selectedProduct.extraCharges) {
      const xk =
        state.selectedProduct.extraCharges.find((e) => e.code === 'XK') || null;
      if (!xk) {
        state.selectedProduct.extraCharges.push({
          code: 'XK',
          title: 'Таможенный сбор',
          description: 'экстрачардж xk',
          cost: {
            exceptions: [],
            value: 200,
          },
          checked_by_default: false,
        });
      }
    }
  },
  updateCalculateResultStored(state, value) {
    state.calculateResultStored = value;
  },
  setPickUpAvailableTimes(state, value) {
    state.pickUpAvailableTimes = value;
  },
  setPickUpAvailableWeekend(state, value) {
    state.pickUpAvailableWeekend = value;
  },
  setPickUpDate(state, value) {
    state.pickUpDate = value;
  },
  setPriceDiff(state, value) {
    state.priceDiff.price = value.price;
    state.priceDiff.transit = value.transit;
    state.priceDiff.continue = value.continue;
  },
  setLegalInfo(state, legalData) {
    state.legalInfo = legalData;
  },
  setInvoiceStatus(state, status) {
    state.invoiceStatus = status;
  },
  setInvoiceType(state, type) {
    state.invoice.type = type;
  },
  setInvoiceCurrency(state, currency) {
    state.invoice.currency = currency;
  },
  setInvoiceItem(state, { id, item }) {
    Vue.set(state.invoice.list, id, item);
  },
  setInvoicePrice(state, price) {
    state.invoice.price = price;
  },
  setCalcDeliverySet(state, { setting, status }) {
    Vue.set(state.calcDeliverySet, setting, status);
  },
  setMarketingNewsletterAllowed(state, status) {
    state.marketingNewsletterAllowed = status;
  },
  setPointWalk(state, status) {
    state.pointWalkDisabled = status;
  },
};

export default mutations;
